import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {useSelector} from 'react-redux';

const ModuloList = ({ itemsPerPage, items, content_4 }) => {

  const [currentItems, setCurrentItems] = useState(null);
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(items?.slice(itemOffset, endOffset));
  }, [itemOffset, itemsPerPage, items]);
  
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      {currentItems && currentItems.map((modulo, index) => (
        <div key={index} className="col-xxl-12">
          <div className="course__item list white-bg mb-10 fix">
            <div className="row gx-0">
              
              <div className="col-xxl-12 col-xl-12 col-lg-12">
                <div className="course__right">
                  <div className={`course__content course__content-4`}>
                    <div className="course__meta d-flex align-items-center">
                      <div className="course__lesson">
                        {/* <span><i className="far fa-book-alt"></i> Pri Zattera</span> */}
                      </div>
                      
                    </div>
                    <h3>
                      <Link to={`/modulo/aula/${modulo.cd_modulo}`}>{modulo.titulo}</Link>
                    </h3>
                    
                  </div>
                  {/* <div className={`course__more course__more-3'}
                   d-flex justify-content-between align-items-center`}>
                    
                    <div className="course__btn">
                      <Link to={`/modulo/aula/${modulo.cd_modulo}`} className="link-btn">
                        Saiba mais
                        <i className="far fa-arrow-right"></i>
                        <i className="far fa-arrow-right"></i>
                      </Link>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}

    </>
  );
};

export default ModuloList;